export default __webpack_public_path__ + "static/media/centro_andes_2_9.f4955dc2.JPG";